import React, {Component} from "react";
import {injectIntl} from "react-intl";

class Own extends Component {

  render() {
    const {intl:{formatMessage}, selected} = this.props;
    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    return (
      <div className="col-sm-6 col-lg-3">
        <div className={["choice-card", selectedCss].join(' ')} onClick={this.props.onSelect}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">{formatMessage({id:'appointment.detail.mobility.own.title'})}</h4>
          </header>
          <div className="choice-card__body">

          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(Own)
